import { TimePicker, type TimePickerProps } from "$components/inputs";
import type { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
/* eslint-disable react/require-default-props */
import React from "react";
import { useController, useFormContext } from "react-hook-form";

interface RHFTimePickerProps
  extends Omit<TimePickerProps, "onChange" | "value"> {
  onChange?: (
    date: MaterialUiPickersDate | null,
    value?: string | null,
  ) => void;
  name: string;
  value?: MaterialUiPickersDate;
}

const RHFTimePicker = (props: RHFTimePickerProps): React.ReactElement => {
  const { name, defaultValue } = props;
  const { control, setValue } = useFormContext();

  const {
    field,
    fieldState: { isTouched, error },
  } = useController({
    name,
    control,
    defaultValue,
  });

  const errStr = isTouched ? error?.message : undefined;

  return (
    <TimePicker
      {...field}
      onChange={(d: MaterialUiPickersDate) => {
        setValue(name, d, {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true,
        });
      }}
      {...props}
      error={errStr}
    />
  );
};

export default RHFTimePicker;
